import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeurl', pure: false })
export class SafeUrl implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    console.log('this.sanitizer.bypassSecurityTrustUrl(url)',this.sanitizer.bypassSecurityTrustUrl(url))
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}